export function sortInputFirst(input, ractSlctRndrChldrnLst) {
   if (!input) {
      return ractSlctRndrChldrnLst;
   }
   var first = [];
   var others = [];
   for (var i = 0; i < ractSlctRndrChldrnLst.length; i++) {
      if (ractSlctRndrChldrnLst[i].props.label.toUpperCase().startsWith(input.toUpperCase())) {
         first.push(ractSlctRndrChldrnLst[i]);
      } else {
         others.push(ractSlctRndrChldrnLst[i]);
      }
   }
   first.sort();
   others.sort();
   return first.concat(others);
}
